import React, { useState } from "react";
import { useIntl } from "@ai360/core/intl";

import { toSelectableCropDropdownOptions, useCropList } from "~/utils/crops/use-crop-list";
import {
    stampCropPurposeSelectable,
    toCropPurposeDropdownOptions,
    useCropPurposeList,
} from "~/utils/crops/use-crop-purpose-list";
import { useLoggedInUserProductScopeOrgLevelGuid } from "~/utils/products/use-product-list";

import AddEditPanelContainer from "./../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { pickLists, unitTypes, dropdowns, service, model } from "./../data";

const ConnectedAddEditPanel = AddEditPanelContainer(AddEditPanel, {
    pickLists,
    unitTypes,
    dropdowns,
    service,
});

const AddEditContainer = (props) => {
    const { formatMessage } = useIntl();
    const orgLevelGuid = useLoggedInUserProductScopeOrgLevelGuid();
    const { crops } = useCropList({ orgLevelGuid });
    const [cropGuid, setCropGuid] = useState(null);
    const { cropPurposes } = useCropPurposeList({ cropGuid, orgLevelGuid });

    return (
        <ConnectedAddEditPanel
            {...props}
            {...{
                [model.PROPS_CROP_NAME]: toSelectableCropDropdownOptions(crops, formatMessage),
                [model.PROPS_CROP_PURPOSE_LIST]: stampCropPurposeSelectable(
                    toCropPurposeDropdownOptions(cropPurposes),
                    formatMessage
                ),
                onCropGuidChange: setCropGuid,
            }}
        />
    );
};

export default AddEditContainer;
